module.exports = __webpack_public_path__ + "static/media/user-red.685287e4.svg";